module.exports = __webpack_public_path__ + "static/media/index_17.f182e9eb.jpg";